import {Component, ElementRef, inject, Inject, OnInit, signal} from '@angular/core';
import {SearchFilterModel} from '../../models/SearchFilter-model';
import {AllMastersDatabaseService} from '../../service/all-masters-database.service';
import {TuningsService} from '../../service/Tunings.service';
import {LocalStorageService} from '../../service/LocalStorageService';
import {normalizeMasterFilters} from '../../shared/constants/master-filter-fields';

@Component({
    selector: 'app-master-records',
    templateUrl: './master-records.component.html',
    styleUrls: ['./master-records.component.css']
})
export class MasterRecordsComponent implements OnInit {

    public filterCount = signal<number>(0);
    public initialLoad = signal<boolean>(true);

    allMasterService = inject(AllMastersDatabaseService);
    tuningService = inject(TuningsService);
    elRef = inject(ElementRef);
    localStorageService = inject(LocalStorageService);

    constructor(@Inject('LOCAL_MASTER_KEY') private masterFilter: string) {
    }

    ngOnInit() {
        this.resetTableValue();
        this.getAllTableHeaderNames();
        this.getAllVersionHeaderNames();

        const savedFilters = normalizeMasterFilters(this.localStorageService.getFilters(this.masterFilter));
        if (savedFilters && savedFilters.length > 0) {
            this.getFilteredRecords(savedFilters);
            this.updateFilterCount(savedFilters.length)
        } else {
            this.getAllMasterRecords();
        }
        setTimeout(() => {
            this.initialLoad.set(false);
        }, 1000);
    }

    getAllMasterRecords() {
        this.allMasterService.getAllMasterRecords();
    }

    getAllTableHeaderNames() {
        this.allMasterService.getAllTableHeaderNames();
    }

    getAllVersionHeaderNames() {
        this.allMasterService.getAllVersionHeaderNames();
    }

    resetTableValue() {
        this.allMasterService.restartTableValues();
    }

    getFilteredRecords(filters: SearchFilterModel[]): void {
        const normalized = normalizeMasterFilters(filters);
        if (normalized.length) {
            this.allMasterService.applyFilters(normalized);
        } else {
            this.allMasterService.getAllMasterRecords();
        }
    }

    getVersionRecord(id: number) {
        this.tuningService.getVersionRecords(id);
    }

    toggleExpandedRow($event: any) {
        let expandedDetail = $event.valueOf();
        this.getVersionRecord(+expandedDetail.id);
        this.allMasterService.toggleExpandedMasterRow(expandedDetail);
    }

    openAdvancedSearchSettings() {
        this.allMasterService.openAdvanceSettings.set(!this.allMasterService.openAdvanceSettings());
    }

    selectFilters(filters: SearchFilterModel[]) {
        this.allMasterService.expandedMaster.set(null);
        this.getFilteredRecords(filters);
        const tableElement: HTMLElement = this.elRef.nativeElement.querySelector('.table-container');
        if (tableElement) tableElement.scrollTop = 0;
    }

    onAdvancedSettingClosed($event: boolean) {
        this.allMasterService.openAdvanceSettings.set($event.valueOf());
    }

    deleteOriginalItems($event: any) {
        let id = $event.valueOf().id;
        let tableName = $event.valueOf().tableName;
        this.allMasterService.deleteMasterFromDatabase(id, tableName);
    }

    downloadFileFromTable($event: any) {
        let id = $event.valueOf().id;
        let winOls = $event.valueOf().winOls;
        let tableName = $event.valueOf().tableName;

        this.allMasterService.downloadMastersFromTable(id, winOls, tableName);
    }

    onRefreshTable() {
        this.allMasterService.searchString.set('');
        const savedFilters = normalizeMasterFilters(this.localStorageService.getFilters(this.masterFilter));
        this.updateFilterCount(savedFilters.length);
        this.getFilteredRecords(savedFilters);
    }

    onSearchInput(value: string) {
        const search = value.trim().toLowerCase();
        this.allMasterService.searchString.set(search);
        if (search.length >= 3) {
            this.allMasterService.getAllMastersByWinOls(search);
        } else if (search.length === 0) {
            this.onRefreshTable();
        }
    }

    deleteTuningRecordFromTable($event: any) {
        let id = $event.valueOf().id;
        let tableName = $event.valueOf().tableName;

        this.tuningService.deleteTuningRecordFromTable(id, tableName);
    }

    downloadTuningRecordFromTable($event: any) {
        let id = $event.valueOf().id;
        let winOls = $event.valueOf().winOls;
        let tableName = $event.valueOf().tableName;

        this.allMasterService.downloadMastersFromTable(id, winOls, tableName);
    }

    editItemDetails($event: any) {
        let element = $event.valueOf().element;
        let winOls = $event.valueOf().winOls;
        let id = $event.valueOf().id;

        this.allMasterService.updateMasterElement(element, winOls, id);
    }

    changeSortDirection($event: any) {
        const tableElement: HTMLElement = this.elRef.nativeElement.querySelector('.table-container');
        this.allMasterService.sortDirectionValues.set($event.valueOf());
        if (tableElement) {
            tableElement.scrollTop = 0;
        }
        this.allMasterService.reloadCurrentMasterRecords();
    }

    isTableEmpty() {
        return this.allMasterService.isTableEmpty();
    }

    updateFilterCount(count: number) {
        this.filterCount.set(count);
    }
}
